import { useQuery } from '@tanstack/react-query';

import { getItemsReplacement } from 'features/order/substitution-flow/infra';

import { ITEMS_REPLACEMENT_MODEL_INIT } from 'features/order/substitution-flow/domain';

import type { GetItemsReplacementParams } from 'features/order/substitution-flow/domain';

export function useGetItemsReplacement(props: GetItemsReplacementParams) {
  const { orderId, query, isProduct, productId, toppingId } = props;
  const _useQuery = useQuery({
    enabled: !!query,
    queryKey: [
      'orders',
      'replacement',
      { orderId, query, isProduct, productId, toppingId },
    ],
    queryFn: () => getItemsReplacement(props),
    staleTime: 2 * 60 * 1_000,
  });
  return {
    ..._useQuery,
    data:
      query && _useQuery.data ? _useQuery.data : ITEMS_REPLACEMENT_MODEL_INIT,
  };
}
